// @ts-nocheck
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useCarouselQueries({ pain, book, tool, useBook, useComments, useMessenger, useStories, aiJob, selectedId }: any) {
  const catalogQ = useQuery({ queryKey: ["carousel-catalog"], queryFn: api.carouselCatalog });
  const sourcesQ = useQuery({
    queryKey: ["carousel-sources", pain, book, tool, useBook, useComments, useMessenger, useStories],
    queryFn: () => api.carouselSources({ pain_id: pain, book_id: book, tool_id: tool, use_book: useBook, use_comments: useComments, use_messenger: useMessenger, use_stories: useStories }),
  });
  const statusQ = useQuery({ queryKey: ["carousel-status"], queryFn: api.carouselStatus });
  const listQ = useQuery({
    queryKey: ["carousels"], queryFn: () => api.carouselList(),
    refetchInterval: (query) => {
      if (aiJob === "publish") return 2000;
      const rows = query.state.data?.items || [];
      return rows.some((row) => row.status === "publishing") ? 2000 : false;
    },
  });
  const rankingQ = useQuery({ queryKey: ["carousel-ranking"], queryFn: api.carouselRanking });
  const musicStatusQ = useQuery({ queryKey: ["carousel-music-status"], queryFn: api.carouselMusicStatus });
  const proposeMusicQ = useQuery({ queryKey: ["carousel-music-propose", selectedId], queryFn: () => api.carouselMusicPropose(selectedId!), enabled: !!selectedId, retry: false });
  const slotQ = useQuery({ queryKey: ["carousel-publish-slot", selectedId], queryFn: () => api.carouselPublishSlot(selectedId || undefined) });
  const currentQ = useQuery({
    queryKey: ["carousel", selectedId], queryFn: () => api.carouselGet(selectedId!), enabled: !!selectedId,
    refetchInterval: (query) => {
      const d = query.state.data;
      if (!d) return false;
      const llm = d.llm_status; const st = d.render_status;
      if (["concepts", "discuss", "copy", "review", "retro", "layout_plan", "inspiration", "draft_critique", "draft_place", "draft_caption", "caption_cta", "design_review", "design_verify", "czasotekst_copy", "copy_chat"].includes(llm)) return 700;
      if (st === "queued" || st === "rendering" || st === "design") return 700;
      if (d.reel_status === "queued" || d.reel_status === "rendering") return 700;
      if (d.status === "publishing" || d.publish_progress?.phase === "publishing") return 700;
      return false;
    },
  });
  return { catalogQ, sourcesQ, statusQ, listQ, rankingQ, musicStatusQ, proposeMusicQ, slotQ, currentQ };
}
